export const footerMoreLinks = {
  'ae-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.ae/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.ae/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.ae/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.ae/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.ae/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.ae/blog/',
          title: 'المدونة',
        },
        {
          href: 'https://www.wingie.ae/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'ae-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.ae/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.ae/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://www.wingie.ae/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.ae/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.ae/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.ae/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'ae-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.ae/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.ae/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://www.wingie.ae/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.ae/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.ae/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.ae/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'ae-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.ae/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.ae/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://www.wingie.ae/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.ae/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.ae/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.ae/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'ae-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.ae/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.ae/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://www.wingie.ae/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.ae/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.ae/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.ae/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'ae-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://www.wingie.ae/it/contact/',
          title: 'Contatti',
        },
        // {
        //     href: 'https://www.wingie.ae/it/faq/',
        //     title: 'Domande frequenti',
        // },
        {
          href: 'https://www.wingie.ae/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://www.wingie.ae/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.ae/it/terms-and-conditions/',
          title: 'Termini e condizioni',
        },
        {
          href: 'https://www.wingie.ae/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'ae-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://www.wingie.ae/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://www.wingie.ae/fr/faq/',
        //     title: 'Questions fréquemment posées',
        // },
        {
          href: 'https://www.wingie.ae/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://www.wingie.ae/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://www.wingie.ae/fr/terms-and-conditions/',
          title: 'Conditions générales',
        },
        {
          href: 'https://www.wingie.ae/fr/awards/',
          title: 'Nos prix',
        },
      ],
    },
  ],
  'ae-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://www.wingie.ae/pt/contact/',
          title: 'Contacto',
        },
        // {
        //     href: 'https://www.wingie.ae/pt/faq/',
        //     title: 'Perguntas frequentes',
        // },
        {
          href: 'https://www.wingie.ae/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://www.wingie.ae/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://www.wingie.ae/pt/terms-and-conditions/',
          title: 'Termos e condições',
        },
        {
          href: 'https://www.wingie.ae/pt/awards/',
          title: 'Os nossos prémios',
        },
      ],
    },
  ],
  'ae-ro': [
    {
      title: 'Mai multe',
      items: [
        {
          href: 'https://www.wingie.ae/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://www.wingie.ae/ro/faq/',
        //     title: 'Întrebări frecvente',
        // },
        {
          href: 'https://www.wingie.ae/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://www.wingie.ae/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://www.wingie.ae/ro/terms-and-conditions/',
          title: 'Termeni și condiții',
        },
        {
          href: 'https://www.wingie.ae/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'ae-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://www.wingie.ae/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://www.wingie.ae/pl/faq/',
        //     title: 'Często zadawane pytania',
        // },
        {
          href: 'https://www.wingie.ae/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://www.wingie.ae/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://www.wingie.ae/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://www.wingie.ae/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'ae-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://www.wingie.ae/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://www.wingie.ae/lt/faq/',
        //     title: 'Dažnai užduodami klausimai',
        // },
        {
          href: 'https://www.wingie.ae/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://www.wingie.ae/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://www.wingie.ae/lt/terms-and-conditions/',
          title: 'Taisyklės ir sąlygos',
        },
        {
          href: 'https://www.wingie.ae/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'ae-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://www.wingie.ae/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://www.wingie.ae/uz/faq/',
        //     title: 'Tez-tez beriladigan savollar',
        // },
        {
          href: 'https://www.wingie.ae/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://www.wingie.ae/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://www.wingie.ae/uz/terms-and-conditions/',
          title: 'Shartlar va qoidalar',
        },
        {
          href: 'https://www.wingie.ae/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'ae-sr': [
    {
      title: 'Više',
      items: [
        {
          href: 'https://www.wingie.ae/sr/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://www.wingie.ae/sr/faq/',
        //     title: 'Često postavljana pitanja',
        // },
        {
          href: 'https://www.wingie.ae/sr/about-us/',
          title: 'O nama',
        },
        {
          href: 'https://www.wingie.ae/sr/privacy/',
          title: 'Privatnost',
        },
        {
          href: 'https://www.wingie.ae/sr/terms-and-conditions/',
          title: 'Uslovi korišćenja',
        },
        {
          href: 'https://www.wingie.ae/sr/awards/',
          title: 'Naše nagrade',
        },
      ],
    },
  ],
  'ae-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        {
          href: 'https://www.wingie.ae/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://www.wingie.ae/ky/faq/',
        //     title: 'Көп берилүүчү суроолор',
        // },
        {
          href: 'https://www.wingie.ae/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://www.wingie.ae/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://www.wingie.ae/ky/terms-and-conditions/',
          title: 'Шарттар жана эрежелер',
        },
        {
          href: 'https://www.wingie.ae/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'ae-tg': [
    {
      title: 'Зиёда',
      items: [
        {
          href: 'https://www.wingie.ae/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://www.wingie.ae/tg/faq/',
        //     title: 'Саволҳои тез-тез пурсидашуда',
        // },
        {
          href: 'https://www.wingie.ae/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://www.wingie.ae/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://www.wingie.ae/tg/terms-and-conditions/',
          title: 'Шартҳо ва қоидаҳо',
        },
        {
          href: 'https://www.wingie.ae/tg/awards/',
          title: 'Мукофотҳои мо',
        },
      ],
    },
  ],
  'ae-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://www.wingie.ae/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://www.wingie.ae/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },
        {
          href: 'https://www.wingie.ae/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://www.wingie.ae/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://www.wingie.ae/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://www.wingie.ae/kk/awards/',
          title: 'Біздің марапаттар',
        },
      ],
    },
  ],
  'ae-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://www.wingie.ae/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://www.wingie.ae/nl/faq/',
        //     title: 'Veelgestelde vragen',
        // },
        {
          href: 'https://www.wingie.ae/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://www.wingie.ae/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.ae/nl/terms-and-conditions/',
          title: 'Algemene voorwaarden',
        },
        {
          href: 'https://www.wingie.ae/nl/awards/',
          title: 'Onze onderscheidingen',
        },
      ],
    },
  ],
  'ae-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.ae/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.ae/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.ae/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.ae/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.ae/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.ae/ja/awards/' },
      ],
    },
  ],
  'ae-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.ae/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.ae/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.ae/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.ae/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.ae/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.ae/zh/awards/' },
      ],
    },
  ],
  'ae-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.ae/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.ae/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.ae/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.ae/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.ae/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.ae/ko/awards/' },
      ],
    },
  ],
  'ae-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.ae/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.ae/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.ae/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.ae/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.ae/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.ae/hi/awards/' },
      ],
    },
  ],
  'ae-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.ae/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.ae/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.ae/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.ae/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.ae/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.ae/ta/awards/' },
      ],
    },
  ],
  'ae-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.ae/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.ae/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.ae/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.ae/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.ae/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.ae/th/awards/' },
      ],
    },
  ],
  'ae-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.ae/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.ae/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.ae/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.ae/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.ae/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.ae/ur/awards/' },
      ],
    },
  ],
  'ae-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.ae/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.ae/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.ae/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.ae/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.ae/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.ae/ka/awards/' },
      ],
    },
  ],
}
